import React        from 'react';
import PropTypes    from 'prop-types';
import ActionStatus from './ActionStatus';

class CardTitle extends React.Component {
	/**
	 * @return {String}
	 */
	render() {
		if (this.props.isAction) {
			return (
				<h4 className="blog-post-card-title__pre">
					<ActionStatus active={this.props.isActionActive} /> &ndash;&nbsp;
					<span dangerouslySetInnerHTML={{__html: this.props.text}} />
				</h4>
			);
		}

		return (
			<h4 className="blog-post-card-title__pre" dangerouslySetInnerHTML={{__html: this.props.text}} />
		);
	}
}

CardTitle.propTypes = {
	isAction:       PropTypes.bool,
	isActionActive: PropTypes.bool,
	text:           PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
};

CardTitle.defaultProps = {
	isAction:       false,
	isActionActive: false,
};

export default CardTitle;
